import { buildEntitySheet, SheetContact } from './entitySheetPdfLayout';

interface SupplierPdfData {
    id: string;
    name: string;
    email?: string;
    phone?: string;
    address?: string;
    notes?: string;
    contact?: SheetContact;
    logoUrl?: string | null;
    /** Noms des catégories du catalogue, dans l'ordre de la fiche. */
    categories?: string[];
    issuerName?: string;
    brandColor?: string;
}

// Fiche fournisseur. Même mise en page ET même catalogue que la fiche partenaire (entitySheetPdfLayout,
// d'après le modèle fourni par Emeni le 2026-08-24) : on liste les CATÉGORIES du fournisseur, pas ses
// articles un par un. Demande d'Emeni (2026-08-24) : « je ne veux pas le nom des articles mais le nom des
// catégories, comme pour le récap des prestataires ». Un fournisseur peut avoir des dizaines de références
// tarifées : la fiche dit ce qu'il fournit, pas son tarif ligne à ligne.
export const generateSupplierPdf = async (data: SupplierPdfData) => {
    try {
        const doc = await buildEntitySheet({
            id: data.id,
            kindLabel: 'Fiche fournisseur',
            name: data.name,
            email: data.email,
            phone: data.phone,
            address: data.address,
            notes: data.notes,
            contact: data.contact,
            logoUrl: data.logoUrl,
            issuerName: data.issuerName,
            brandColor: data.brandColor,
            sections: [{
                title: 'Catalogue de catégories',
                rows: (data.categories || []).map((label) => ({ left: label })),
                emptyLabel: 'Aucune catégorie renseignée pour ce fournisseur.',
            }],
        });
        const cleanName = data.name.replace(/[^a-zA-Z0-9]/g, '_');
        doc.save(`Fournisseur_${cleanName}.pdf`);
    } catch (e) {
        console.error('Supplier PDF Generation Error:', e);
        alert('Erreur lors de la génération du document PDF.');
    }
};
